import React from "react"
import { siteUrl } from "../../../shared/utils/siteUrl"
import "./pre-parental-authorization.scss"
import Button from "../../../shared/components/atoms/button/button"
import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal"
import { registerStepDatalayer } from "../../../utils/registerDatalayer"

const PreparentalAuthorization = props => {
  var homeLink = siteUrl + "/"

  const activityRedirect = () => {
    localStorage.removeItem('PREV_PARAMS')
     window.location.href = props.urlActivity ? `${siteUrl}/${props.urlActivity}` : homeLink
  }

  return (
    <GenericModal>
      <div className="f-modal-info">
        <div className="f-main-title-container">
          <label className="f-main-title">¡Estás muy cerca!</label>
        </div>
        <div className="f-sub-title-container-generic">
          <h2 className="f-sub-title">
            SOLO FALTA LA AUTORIZACIÓN DE TUS PADRES
          </h2>
        </div>
        <div className="f-description-container">
          <p className="f-description">
            Una vez tus padres verifiquen tu información, llegará un enlace de
            activación de tu cuenta a tu correo o celular.
          </p>
        </div>

        <div className="f-btn-container">
          <div className="f-btn-interaction-container">
            <Button
              onClick={e => {
                e.preventDefault()
                registerStepDatalayer({ category: "verificar_acudiente", label: "estoy de acuerdo" })
                sessionStorage.removeItem("userData")
                activityRedirect()
              }}
              title="¡Estoy de acuerdo!"
              className="new-primary-pink"
            />
          </div>
        </div>
      </div>

      <a href={props.urlActivity ? `${siteUrl}/${props.urlActivity}` : homeLink}>
        <span className="icon2-close f-icon f-close-icon"></span>
      </a>
    </GenericModal>
  )
}

export default PreparentalAuthorization
